import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private notificationSubject = new Subject<any>();

  setNotification(messageContent: string, notificationStyle: string, notificationFade: boolean){
    this.notificationSubject.next({message: messageContent, style: notificationStyle, fade: notificationFade});
  }

  getNotificationSubject(): Observable<any>{
    return this.notificationSubject.asObservable();
  }


}
